import { httpApi } from './http.api';
import { UserModel } from '@app/domain/UserModel';

export interface AuthData {
  username: string;
  password: string;
}

export interface SignUpRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface SecurityCodePayload {
  code: string;
}

export interface NewPasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  data: {
    token: string;
  };
}

export interface GetProfileResponse {
  data: UserModel;
}

export interface UpdateRequest {
  fullName: string;
}

export interface UpdateResponse {
  data: UpdateRequest;
}

export const login = async (loginPayload: LoginRequest): Promise<LoginResponse> =>
  httpApi.post<LoginResponse>('/login', { ...loginPayload }).then(({ data }) => data);

export const getProfile = async (): Promise<UserModel> =>
  httpApi.get<GetProfileResponse>('/profile').then(({ data }) => data.data);

export const updateProfile = async (updatePayload: UpdateRequest): Promise<UpdateResponse> =>
  httpApi.patch<UpdateResponse>('/profile', { ...updatePayload }).then(({ data }) => data);

export const setNewPassword = (newPasswordData: NewPasswordData): Promise<undefined> =>
  httpApi.patch<undefined>('/password', { ...newPasswordData }).then(({ data }) => data);

export const signUp = (signUpData: SignUpRequest): Promise<undefined> =>
  httpApi.post<undefined>('signUp', { ...signUpData }).then(({ data }) => data);

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<undefined> =>
  httpApi.post<undefined>('forgotPassword', { ...resetPasswordPayload }).then(({ data }) => data);

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<undefined> =>
  httpApi.post<undefined>('verifySecurityCode', { ...securityCodePayload }).then(({ data }) => data);
